import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { SignatureActions } from './signature.actions';
import { ISignatureState } from './signature.state';

export const initialSignatureState: ISignatureState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const signatureReducerFn = createReducer(
  initialSignatureState,
  on(SignatureActions.reset, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(initialSignatureState).build();
  }),

  on(SignatureActions.updateFormStatus, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state).toLoading().build();
  }),
  on(SignatureActions.updateFormStatusSuccess, (state: ISignatureState, action) => {
    const { groupPreview } = action;
    const { data } = state;
    const formGroups = data.formGroups.slice();

    let targetGroup = formGroups.find((group) => group.code == groupPreview.code);
    const targetForms = targetGroup.forms.slice().map((form) => {
      const signedState = {
        ...form,
        ...{ signed: true }
      };
      return signedState;
    });

    targetGroup = {
      ...targetGroup,
      ...{ signed: true },
      ...{ forms: [...targetForms] }
    };

    const groupIndex = formGroups.findIndex((group) => group.code == groupPreview.code);
    formGroups.splice(groupIndex, 1, targetGroup);

    return {
      ...state,
      ...{
        data: {
          ...data,
          ...{ formGroups: [...formGroups] }
        }
      }
    };

    // const clonedGroups = formGroups.slice();
    // const groupIndex = clonedGroups.findIndex((group) => group.code == groupPreview.code);
    // clonedGroups.splice(groupIndex, 1, moduleData);

    // return new StateBuilder<ISignatureState>(state, action).toLoaded().build();
  }),
  on(SignatureActions.updateFormStatusFailure, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state, action).toLoaded().build();
  }),

  on(SignatureActions.loadFormsPreview, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state).toLoading().build();
  }),
  on(SignatureActions.loadFormsPreviewSuccess, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state, action).toLoaded().build();
  }),
  on(SignatureActions.loadFormsPreviewFailure, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state, action).toLoaded().build();
  }),
  on(SignatureActions.submit, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state, action).toLoading().build();
  }),
  on(SignatureActions.submitSuccess, (state: ISignatureState, action) => {
    return new StateBuilder<ISignatureState>(state, action).toLoaded().build();
  })
);

export function signatureReducer(state: ISignatureState | undefined, action: Action) {
  return signatureReducerFn(state, action);
}
